import { defineAbility } from '@casl/ability';
const rolesOfBo = [ "OperateurBackOfficeExterne", "Administrateur", "OperateurBackOfficeInterne"];
const rolesOfLocataire = ["Locataire"];
const rolesOfBailleur = [ "BailleurAdministrateur", "Bailleur"]

export function defineUserAbilities(roles, connectedUserId, userData) {
    const showAdminsGerant = userData?.userDto?.roles?.length > 0 && userData?.userDto?.roles?.some((role) => ["Bailleur"].includes(role)) 

    const isAdminGerant = userData?.admins?.some((item) => item?.id == connectedUserId)

    const canUpdateOrDeleteUser = roles?.some((role) => ["Administrateur", "BailleurAdministrateur"].includes(role) )

    return defineAbility((can) => {
        can('read', 'Bailleur');
        can('read', 'User');
        can('read', 'campagne');
     
       
        if (canUpdateOrDeleteUser) {
            can('delete', 'User');
            can('update', 'User');
            can('remindByMail', 'User')

        }
        if (roles?.some((role) => ["Administrateur", "BailleurAdministrateur"].includes(role)) ){
            can('add', 'User');
        }
        if (showAdminsGerant) {
            can('readAdminsGerant', 'User')
        }
        if (roles?.some((role) => ["Administrateur"].includes(role))) {
            can('add', 'Bailleur');
            can('add', 'Campagne');
            can('update', 'Bailleur');
            can('update', 'Campagne');
            can('delete', 'Bailleur');
            can('delete', 'Campagne');
        }
    });
}